import { createFileRoute } from "@tanstack/react-router"
import { LiveEventLayout } from "@/features/live-events-admin/LiveEventLayout"

export const Route = createFileRoute("/live-events/$eventId")({
	component: LiveEventLayout,
})
